import * as yup from 'yup';

const loginSchema = yup.object().shape({
  email: yup.string().email('common.errors.email').required('common.required'),
  password: yup.string().required('common.required'),
});

export default loginSchema;
